/**
 * Validacao e normalizacao do payload IA_CONTEXTO_TELA recebido de um iframe.
 *
 * O shell NUNCA confia neste conteudo como permissao: identificadores sao so
 * ponteiros que o backend revalida contra o escopo do usuario, e o resumo
 * textual e tratado como dado nao confiavel (envelopado e sanitizado) no
 * prompt, nunca como instrucao. Este modulo so limita o formato/tamanho antes
 * de guardar em estado, para reduzir a superficie do que um iframe pode
 * empurrar para o contexto do chat.
 */

const LIMITE_TELA = 60;
const LIMITE_ROTA = 200;
const LIMITE_ITEM_RESUMO = 200;
const MAXIMO_ITENS_RESUMO = 20;
const IDENTIFICADORES_PERMITIDOS = ['codPpc', 'codCliente', 'codOperacao'];

const truncar = (valor, limite) => (typeof valor === 'string' ? valor.slice(0, limite) : '');

const normalizarIdentificadores = identificadores => {
  if (!identificadores || typeof identificadores !== 'object') {
    return {};
  }

  return IDENTIFICADORES_PERMITIDOS.reduce((acc, chave) => {
    const valor = identificadores[chave];
    if (typeof valor === 'number' && Number.isFinite(valor)) {
      acc[chave] = valor;
    } else {
      acc[chave] = null;
    }
    return acc;
  }, {});
};

const normalizarResumo = resumo => {
  if (!resumo || typeof resumo !== 'object') {
    return {};
  }

  const entradas = Object.entries(resumo).slice(0, MAXIMO_ITENS_RESUMO);

  return entradas.reduce((acc, [chave, valor]) => {
    if (typeof chave !== 'string' || chave.length > 60) {
      return acc;
    }

    if (typeof valor === 'string') {
      acc[chave] = truncar(valor, LIMITE_ITEM_RESUMO);
    } else if (Array.isArray(valor)) {
      acc[chave] = valor
        .filter(item => typeof item === 'string')
        .slice(0, MAXIMO_ITENS_RESUMO)
        .map(item => truncar(item, LIMITE_ITEM_RESUMO));
    }
    // numeros/booleanos simples tambem sao aceitos como estao
    else if (typeof valor === 'number' || typeof valor === 'boolean') {
      acc[chave] = valor;
    }

    return acc;
  }, {});
};

/**
 * @returns {object|null} payload normalizado, ou null se o formato basico for invalido.
 */
export const normalizarContextoTela = dadosBrutos => {
  if (!dadosBrutos || dadosBrutos.type !== 'IA_CONTEXTO_TELA') {
    return null;
  }

  if (dadosBrutos.versao !== 1) {
    return null;
  }

  return {
    versao: 1,
    tela: truncar(dadosBrutos.tela, LIMITE_TELA),
    rota: truncar(dadosBrutos.rota, LIMITE_ROTA),
    identificadores: normalizarIdentificadores(dadosBrutos.identificadores),
    resumo: normalizarResumo(dadosBrutos.resumo),
    recebidoDe: null // preenchido pelo chamador com event.origin, ja validado pela allowlist
  };
};
